import {Component} from "@angular/core";
import {NavService} from "../services/nav/nav.service";
import {UserModelService} from "../services/usermodel/usermodel.service";
import {EventBus} from "../event/EventBus";
import {RecordingStatusEvent, RECORDING_STATUS} from "../event/ReadAndRecordEvents";
import {ComponentBase} from "../base/ComponentBase";
import {Router, NavigationEnd, NavigationError} from "@angular/router";
import {ModalConfig} from "../services/notification/modal.config";
import {Login} from "../login/login";
import {Scilearn} from "../constants";
import {ReportEventData} from "../event/ActivityEvent";
import {CompletionState} from "../services/usermodel/usermodel.objects";
import {PointService} from "../services/points/points.service";
import {RaVersion} from "../services/configuration/ra.version";
import {MicrophoneCheckEvent, MICROPHONECHECK_STATUS} from "../event/MicrophoneCheckEvent";
import {PleaseWaitEvent, PleaseWaitTarget} from "../event/ContentEvents";
import {ActivityEvent, ACTIVITY_STATUS, ActivityEventData} from "../event/ActivityEvent";
import {ExitButtonEnabler} from "./exit-button.enabler";
import {AudioQueueService} from "../services/audio-playback/audioqueue.service";
import {StepService} from "../services/step/step.service";
import {WordWallRecordingService} from "../services/recording/wordwall.recording.service";
import {NetworkService} from "../services/interaction/network.service";
import {GAEventService} from "../services/analytics/GAEventServce";

@Component({
   selector: "nav-header",
   templateUrl: "./nav.component.html",
   styleUrls: ["./nav.component.scss"]
})
export class NavComponent extends ComponentBase {

    public learnerName: string;
    public navEnabled: boolean = false;
    public currentUrl: string;
    public intermediate:string;
    public selectedItem: string;

    constructor(private navService: NavService,
                private eventBus: EventBus,
                private loginConfiguration: Login,
                private router: Router,
                private modalConfig: ModalConfig,
                private userModelService: UserModelService,
                private exitButtonEnabler: ExitButtonEnabler,
                private audioQueueService: AudioQueueService,
                private stepService: StepService,
                private wordWallRecordingService: WordWallRecordingService,
                private networkService: NetworkService,
                public pointService: PointService,
                private gaEventService: GAEventService)  {
        super("NavComponent");
    }

    ngOnInit(): void {
        this.listenForRouteChange();
        this.selectedItem = 'Library';
    }

    private listenForRouteChange(): void {
        this.router.events.subscribe((event: NavigationEnd) => {
            let url = event.urlAfterRedirects || event.url;

            if (url) {
                this.currentUrl = url;
            }

            this.learnerName = this.loginConfiguration.name;
            if (url && !!url.match("/hide")) {
                this.navEnabled = false;
            } else if (url && !!url.match("/library")) {
                this.navEnabled = true;
            }
        });

        this.router.events.subscribe((event: NavigationError) => {
            console.log(event);
        });
    }

    public isReadingViewCurrently(): boolean {
        return this.currentUrl && !!this.currentUrl.match("/reading");
    }

    public exit(): void {
        if (this.exitBtnEnabled()) {
            this.modalConfig.openMessageModal("exit_confirm");
        }
    }

    public go(route: string|any[]): void {
        if (!this.networkService.isOnline()) {
            this.modalConfig.openMessageModal("exit_while_offline");
            return;
        }

        if (!!this.router.url.match(route.toString())) {
            return;
        }

        if (!!route.toString().match("library")) {
            this.eventBus.next(
                new ActivityEvent(ACTIVITY_STATUS.activity_end, new ActivityEventData({
                    type: "glossary"
                })));
        }

        this.audioQueueService.reset().subscribe(() => {
            this.eventBus.next(new PleaseWaitEvent({show: true, audio: true, destination: PleaseWaitTarget.ANY}));
            this.navService.navigate((Array.isArray(route) ? route : [route]));
        });
    }

    public buttonsEnabled(): boolean {
        return !(this.stepService.startedReadOrRecordActivity && this.isReadingViewCurrently()) &&
                 !this.wordWallRecordingService.isWordInWordWallSelected();
    }

    public pointsEnabled(): boolean {
        return !this.isReadingViewCurrently() && this.pointService.currentPoints() > 0;
    }

    public fluencyBtnEnabled(): boolean {
        return this.userModelService.recordCount > 0 && this.isReadingViewCurrently() &&
               !this.stepService.startedReadOrRecordActivity;
    }

    public selectionBtnEnabled(): boolean {
        return (this.userModelService.storyCompletionState === CompletionState.COMPLETED) &&
            this.isReadingViewCurrently() && !this.stepService.startedReadOrRecordActivity;
    }

    public exitBtnEnabled(): boolean {
        return this.exitButtonEnabler.isEnabled() && !this.wordWallRecordingService.isWordInWordWallSelected();
    }

    public openFluencyReport(): void {
        let isAutomatic = false;
        this.gaEventService.emitEvent("report", "fluency", "click", 1);
        if (this.fluencyBtnEnabled()) {
            this.modalConfig.openModal(new ReportEventData({storyUniqName: null, type: Scilearn.FLUENCY_MODAL,
                automatic: isAutomatic, storyLoaded: true}));
        }
    }

    public openSelectionReport(): void {
        let isAutomatic = false;
        this.gaEventService.emitEvent("report", "selection", "click", 1);
        if (this.selectionBtnEnabled()) {
            this.modalConfig.openModal(new ReportEventData({storyUniqName: null, type: Scilearn.SELECTION_MODAL,
                automatic: isAutomatic, storyLoaded: true}));
        }
    }

    public openCreditsModal(): void {
        this.modalConfig.openModal(new ReportEventData({storyUniqName: null, type: Scilearn.CREDITS_MODAL,
            automatic: false, storyLoaded: false}));
    }

    public openHelpModal(): void {
        this.modalConfig.openModal(new ReportEventData({storyUniqName: null, type: Scilearn.HELP_MODAL,
            automatic: false, storyLoaded: false}));
    }

    public openSysinfoModal(): void {
        this.modalConfig.openModal(new ReportEventData({storyUniqName: null, type: Scilearn.SYSINFO_MODAL,
            automatic: false, storyLoaded: false}));
    }

    public openMicCheck(): void {
        this.eventBus.next(new MicrophoneCheckEvent(MICROPHONECHECK_STATUS.manual));
    }

    public navItemClick(value : any) : void {
        this.selectedItem = value.currentTarget.innerText;
    }
}
